export default __webpack_public_path__ + "static/11.05-bbe55feb989c5d98cad5f3b91a5f49f6.png";